import FormattedDateCell from 'components/table/cells/common/FormattedDateCell';
import { CellContext } from '@tanstack/react-table';
import { AutomatedReviewLog } from 'models/automation/Reviews';
import Tooltip from 'components/tooltip/Tooltip';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

const ReviewDateCell = (props: CellContext<AutomatedReviewLog, string>) => {
  const { t } = useTranslation();
  const { getValue, row } = props;

  const value = getValue();
  const date = typeof value === 'string' ? parseISO(value) : value;

  if (!date) {
    return t('common.notApplicable');
  }

  return (
    <Tooltip
      delay={1000}
      id={`tooltip-cell-date-full-${row.id}`}
      text={format(date, 'ccc, MMMM d, yyyy, h:mm a zzz')}
    >
      <FormattedDateCell {...props} />
    </Tooltip>
  );
};

export default ReviewDateCell;
